module.exports = __webpack_public_path__ + "img/birthday-cake-1.1c1f9efe.svg";